import { createContext } from 'react'
export const TagGroupContext = createContext(null)
